import React, { Component } from 'react'
import TagsInput from 'react-tagsinput'
import Autosuggest from 'react-autosuggest'
 
import 'react-tagsinput/react-tagsinput.css' // If using WebPack and style-loader.
import './Tags.css'

export default class Tags extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      tags: props.value || [],
      maxSuggestions: props.value || 7,
      suggestions: props.suggestions || [],
      placeholder: props.placeholder || "Type here to add a tag...",
    }

    this.handleChange = this.handleChange.bind(this);
  }
 
  handleChange(tags) {
    this.setState({tags})

    if(this.props.onChange){
      this.props.onChange(tags);
    }
  }

  componentWillReceiveProps(props){
    var v = props.value
    if(!v) v = [];

    this.setState({
      tags: v
    })
  }

  pasteSplit(data) {
    console.log(data);
    const separators = [',', ';', '\\(', '\\)', '\\*', '/', ':', '\\?', '\n', '\r'];
    let split = data.split(new RegExp(separators.join('|'))).map(d => d.trim());

    return split;
  }
 
  render() {

    const props = this.props;

    var that = this;

    function autocompleteRenderInput ({addTag, ...props}) {
      const handleOnChange = (e, {newValue, method}) => {
        if (method === 'enter') {
          e.preventDefault()
        } else {
          props.onChange(e)
        }
      }

      const inputValue = (props.value && props.value.trim()) || ''
      const inputLength = inputValue.length

      let suggestions = that.props.suggestions.filter((item) => {

        // starting with
        // var matches = item.toLowerCase().slice(0, inputLength) === inputValue.toLowerCase();

        // contains
        var matches = item.toLowerCase().indexOf(inputValue.toLowerCase()) > -1;

        var alreadyAdded = that.state.tags.indexOf(item) > -1;
        return (matches && !alreadyAdded);
      })

      suggestions.sort(function(a,b){
        if(a < b) return -1;
        if(a > b) return 1;
        return 0;
      }) 

      suggestions = suggestions.slice(0, props.maxSuggestions);

      return (
        <Autosuggest
          ref={props.ref}
          suggestions={suggestions}
          shouldRenderSuggestions={(value) => value && value.trim().length > 0}
          getSuggestionValue={(suggestion) => suggestion}
          renderSuggestion={(suggestion) => <span>{suggestion}</span>}
          inputProps={{...props, onChange: handleOnChange}}
          onSuggestionSelected={(e, {suggestion}) => {
            addTag(suggestion)
          }}
          onSuggestionsClearRequested={() => {}}
          onSuggestionsFetchRequested={() => {}}
        />
      )
    }

    return <div className="tags">
      <TagsInput 
        renderInput={autocompleteRenderInput}
        value={this.state.tags} 
        onChange={this.handleChange} 
        inputProps={{
          placeholder: this.props.placeholder
        }}
        validationRegex={this.props.validationRegex}
        onValidationReject={this.props.onValidationReject}
        addOnPaste={true}
        pasteSplit={this.pasteSplit}
        />
    </div>
  }
}


// WEBPACK FOOTER //
// ./src/components/Tags/Tags.js